import * as React from 'react';
import cn from '~modules/cn';

import './chip.scss';

export type Props = {
    text: React.ReactNode;
    type: 'outline' | 'primary' | 'positive';
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    className?: string;
    onClick?: (e: React.MouseEvent) => void;
    dataTip?: string;
    dataTipOverflow?: boolean;
};

export const Chip = React.forwardRef<HTMLDivElement, Props>((props, ref) => (
    <div
        ref={ref}
        className={cn('chip', `chip--${props.type}`, props.className)}
        onClick={props.onClick}
        data-tip={props.dataTip}
        data-tip-overflow={props.dataTipOverflow}
    >
        {props.startIcon && <div className="chip__icon">{props.startIcon}</div>}
        {props.text}
        {props.endIcon && <div className="chip__icon">{props.endIcon}</div>}
    </div>
));
Chip.displayName = 'Chip';

export default Chip;
